/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { View } from '@az/starc-ui';
import styles from './CMSBlogRichText.module.scss';
import { useCallback } from 'react';
import { clickTrack } from '@/utils/analytics/clickTrack';

type CMSBlogRichTextProps = {
  content?: string;
  textRef?: React.RefObject<HTMLDivElement | null>;
};

/**
 * Renders rich HTML content from the CMS.
 * Assumes `content` is trusted and already sanitized upstream.
 */
export const CMSBlogRichText = ({ content, textRef }: CMSBlogRichTextProps) => {
  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    const anchor = (event.target as HTMLElement).closest('a');
    if (anchor) {
      if (anchor.href.includes('intcmp')) {
        clickTrack({
          productFindingMethod: 'Internal Campaign',
          internalCampaignInteraction: 'internalCampaignInteraction',
          pfmlocation: 'Blogs Page',
        });
      }
    }
  }, []);

  if (!content) {
    return null;
  }

  return (
    <View
      attributes={{
        dangerouslySetInnerHTML: { __html: content },
        ref: textRef,
        onClick: handleClick,
      }}
      className={styles.rteStyles}
    />
  );
};
